import { createVNode as _createVNode, resolveComponent as _resolveComponent, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "login-box" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"logo-wrap\"><a href=\"#\"><img src=\"img/logo.png\"></a></div><hr><div class=\"login-header mb-2\"><div><h1 class=\"mb-1\">Reset password</h1><p class=\"text-muted\"><small>Please enter new password to reset.</small></p></div></div>", 3)
const _hoisted_6 = { class: "form-wrap pt-0" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", { for: "" }, "New password", -1)
const _hoisted_9 = { class: "password-field" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye-slash" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }, null, -1)
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { for: "" }, "Confirm new password", -1)
const _hoisted_14 = { class: "password-field" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye-slash" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }, null, -1)
const _hoisted_17 = { class: "modal-wrap default-modal success-modal" }
const _hoisted_18 = {
  class: "modal fade show",
  "data-keyboard": "false",
  id: "resetSuccessModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-modal": "true",
  role: "dialog",
  "aria-hidden": "true",
  "data-backdrop": "static"
}
const _hoisted_19 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_20 = { class: "modal-content" }
const _hoisted_21 = { class: "modal-header" }
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "modal-body text-center" }, [
  /*#__PURE__*/_createVNode("div", { class: "success-body mb-2" }, [
    /*#__PURE__*/_createVNode("img", { src: "app/img/checked.png" }),
    /*#__PURE__*/_createVNode("h5", null, "Password reset successfull"),
    /*#__PURE__*/_createVNode("p", null, "Your password has been successfully changed.")
  ])
], -1)
const _hoisted_24 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_ErrorList, {
            errors: _ctx.state.ui.error.validationList,
            hasError: _ctx.state.ui.error.hasError
          }, null, 8, ["errors", "hasError"]),
          _createVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode("div", _hoisted_9, [
              _withDirectives(_createVNode("input", {
                type: _ctx.state.data.isPasswordShow ? 'text' : 'password',
                class: "form-control mb-2",
                placeholder: "Enter new password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.data.resetPassword.password = $event))
              }, null, 8, ["type"]), [
                [_vModelDynamic, _ctx.state.data.resetPassword.password]
              ]),
              (_ctx.state.data.isPasswordShow)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    class: "field-icon",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showPassword && _ctx.showPassword(...args)))
                  }, [
                    _hoisted_10
                  ]))
                : (_openBlock(), _createBlock("button", {
                    key: 1,
                    class: "field-icon",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showPassword && _ctx.showPassword(...args)))
                  }, [
                    _hoisted_11
                  ]))
            ])
          ]),
          _createVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode("div", _hoisted_14, [
              _withDirectives(_createVNode("input", {
                type: _ctx.state.data.isConfirmPasswordShow ? 'text' : 'password',
                class: "form-control mb-2",
                placeholder: "Confirm new password",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.resetPassword.confirmPassword = $event))
              }, null, 8, ["type"]), [
                [_vModelDynamic, _ctx.state.data.resetPassword.confirmPassword]
              ]),
              (_ctx.state.data.isConfirmPasswordShow)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    class: "field-icon",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showConfirmPassword && _ctx.showConfirmPassword(...args)))
                  }, [
                    _hoisted_15
                  ]))
                : (_openBlock(), _createBlock("button", {
                    key: 1,
                    class: "field-icon",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showConfirmPassword && _ctx.showConfirmPassword(...args)))
                  }, [
                    _hoisted_16
                  ]))
            ])
          ])
        ]),
        _createVNode("a", {
          href: "javascript:void(0)",
          class: "btn button-gradient d-block",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.sendResetPassword && _ctx.sendResetPassword(...args)))
        }, _toDisplayString(_ctx.state.ui.postLoading.sendForgetPasswordForVerification
          ? "Confirm..."
          : "Confirm"), 1)
      ])
    ]),
    _createVNode("div", _hoisted_17, [
      _createVNode("div", _hoisted_18, [
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, [
              _createVNode("button", {
                type: "button",
                class: "close",
                "aria-label": "Close",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.hideResetSuccessModal && _ctx.hideResetSuccessModal(...args)))
              }, [
                _hoisted_22
              ])
            ]),
            _hoisted_23,
            _createVNode("div", _hoisted_24, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn w-100",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.hideResetSuccessModal && _ctx.hideResetSuccessModal(...args)))
              }, " Continue ")
            ])
          ])
        ])
      ])
    ])
  ]))
}